import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { Observable, throwError, Subscription } from 'rxjs';
import { catchError, debounceTime } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';
import Swal from 'sweetalert2';

import { EditExpenseModalComponent } from '@teem/expenses-module/modals/edit-expense-modal/edit-expense-modal.component';

import { parseDate, checkMobileView, queryString } from '@teem/helpers/functions';
import { ExpenseService } from '@teem/services/expense.service';
import { LoaderService } from '@teem/services/loader.service';
import { environment } from '@teem/environments/environment';
import { ExpenseForm } from '@teem/model-forms/expense-form';
import { expense as ExpenseApi } from '@teem/constants/api';
import { messages as i18n } from '@teem/constants/messages';
import { Expense } from '@teem/models/expense';
declare var $;

@Component({
  selector: 'expenses-table',
  templateUrl: './expenses-table.component.html',
  styles: []
})

export class ExpensesTableComponent implements OnInit {
  @Input() invoicesList: Array<any>;
  @Input() isProPlan: any;
  @Input() userInfo;
  @Output() perPageItems: EventEmitter<any> = new EventEmitter();
  @Output() onLoad: EventEmitter<any> = new EventEmitter();
  @Output() onChange: EventEmitter<any> = new EventEmitter();
  serverUrl: string = ExpenseApi.all;
  data: Array<object> = [];
  timeFilter: string;
  categoryFilter: string;
  search = new Subject<string>();
  searchText: string;
  itemsPerPageOptions = [10, 20, 50, 100];
  paginator: any = {
    id: 'expenses-table-paginator',
    currentPage: 1,
    itemsPerPage: environment.pageSize,
    totalItems: 0
  }
  loading: boolean = false;
  searchSubscription: Subscription;
  dataSubscription: Subscription;
  expenses = new FormArray([]);
  isMobileView: boolean = checkMobileView();
  fromDate: any = null;
  toDate: any = null;
  expensesDetails: any = null;

  constructor(
    private fb: FormBuilder,
    private httpClient: HttpClient,
    private loaderService: LoaderService,
    private expenseService: ExpenseService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.searchSubscription = this.search.asObservable().pipe(debounceTime(300)).subscribe(data => {
      if (this.searchText != data) {
        this.searchText = data;

        if (this.searchText.length == 0 || this.searchText.length >= 3) {
          this.getPage(1, false);
        }
      }
    })

    this.getPage(1);
  }

  ngOnDestroy() {
    this.searchSubscription.unsubscribe()
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isMobileView = checkMobileView();
  }

  isSubmitted(form: FormGroup) {
    return form.get('submitted').value;
  }

  resetDateFilters() {
    this.fromDate = null;
    this.toDate = null
  }

  public getPage(page: number, loading: boolean = true, additionalParams: any = null) {

    // Unselect selected items
    if (loading) {
      this.loaderService.startLoading();
      this.loading = true; // to show loading text in table
    }

    let params: any = {
      page: page,
      limit: this.paginator.itemsPerPage
    }

    if (this.searchText && this.searchText.length >= 3) {
      params.q = this.searchText;
    }

    if (this.timeFilter) {
      params.filter_by = this.timeFilter
    }

    if (additionalParams) {
      Object.assign(params, additionalParams);
    }

    if (params.from_date) {
      this.fromDate = parseDate(params.from_date);
    }

    if (params.to_date) {
      this.toDate = parseDate(params.to_date);
    }

    if (this.fromDate)
      params.from_date = this.fromDate;

    if (this.toDate)
      params.to_date = this.toDate;

    if (this.categoryFilter)
      params.category = this.categoryFilter;

    this.getData(params).subscribe(r => {
      if (r.data) {
        this.data = r.data;

        this.expenses = new FormArray([]);

        r.data.forEach(expense => {
          this.addExpense(expense);
        })
      }

      if (r.meta) {
        this.paginator.totalItems = r.meta.total;
        this.paginator.currentPage = r.meta.current_page;
        this.paginator.from = r.meta.from;
        this.paginator.to = r.meta.to;
        this.data = r.data;

        this.onLoad.emit({
          totalItems: r.meta.total
        });
      }

      this.loaderService.stopLoading();
      this.loading = false;
      setTimeout(() => {
        $('#tab-links-select[nice-select]').niceSelect('update');
      }, 100);
    }, (err) => {
      this.loading = false;
      this.loaderService.stopLoading()
    })
  }

  getData(params): Observable<any> {
    let url = this.serverUrl;

    if (url.indexOf('?') == -1)
      url += ('?' + queryString(params));
    else
      url += ('&' + queryString(params));

    return this.httpClient.get(`${url}`).pipe(
      catchError((err: any) => {
        this.loaderService.stopLoading()
        return throwError(err);
      })
    )
  }

  addExpense(form: any) {
    this.expenses.push(
      this.fb.group(
        new ExpenseForm(new Expense(form))
      )
    )
  }


  onSubmitEditExpense(form: FormGroup) {
    form.get('submitted').setValue(true);
    if (form.valid) {

      this.loaderService.startLoading();

      let fd = form.value;
      fd.vat_include = fd.vat_include ? 1 : 0;
      fd.expense_date = parseDate(fd.expense_date);

      delete fd.edit;
      delete fd.submitted;

      this.expenseService.update(fd).subscribe(data => {

        this.loaderService.stopLoading();

        Swal.fire(i18n.done, i18n.expense.expense_updated, 'success');
        form.get('submitted').setValue(false);
        this.getPage(1);

        // Trigger change event in parent component
        this.onChange.emit(true);
      }, err => {
        this.loaderService.stopLoading();

        // Set server side error
        if (err.status === 422) {
          if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
            let validationErrors = err.error.errors;
            Object.keys(validationErrors).forEach((prop) => {
              form.get(prop)?.setErrors({
                serverError: validationErrors[prop]
              })
            })
          }
        }

        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      })
    }
  }
// 
  deleteExpense(form: FormGroup) {
    Swal.fire({
      title: i18n.are_you_sure,
      text: i18n.expense.you_want_to_delete_expense,
      icon: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText:
        i18n.yes,
      cancelButtonText:
        i18n.no_cancel_it
    }).then(result => {
      if (result.value) {
        this.loaderService.startLoading();
        this.expenseService.delete(form.value.uuid).subscribe(r => {
          this.loaderService.stopLoading();

          Swal.fire(i18n.done, i18n.expense.expense_deleted, 'success');
          this.getPage(1);

          // Trigger change event in parent component
          this.onChange.emit(true);
        }, err => {
          this.loaderService.stopLoading();

          Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        })
      }
    })
  }


  editExpenses(form: FormGroup) {
    this.loaderService.startLoading();
    let fd = form.value;
    this.expenseService.get(fd.uuid).subscribe(expensesDetails => {
      this.expensesDetails = expensesDetails;
      this.openEditExpensesModal();
      this.loaderService.stopLoading();
    }, err => {
      this.loaderService.stopLoading();
    })
  }

  openEditExpensesModal() {
    let modalRef = this.modalService.open(EditExpenseModalComponent);
    modalRef.componentInstance.expenseInfo = this.expensesDetails;
    modalRef.componentInstance.isProPlan = this.isProPlan;
    modalRef.componentInstance.el.nativeElement.parentNode.parentNode.id = "newexpenses";

    modalRef.result.then(
      onfulfilled => {
        // Trigger change event in parent component
        this.getPage(1);
        this.onChange.emit(true);
      },
      onrejected => {

      }
    );
  }

  onChangeItemsPerPage(event: Event, api: any) {
    console.log('child')
    const selectElement = event.target as HTMLSelectElement;
    this.perPageItems.emit({ limit: +selectElement.value });
    this.paginator.itemsPerPage = +selectElement.value;
  }

  openRecallExpenseModal(form: FormGroup) {
    Swal.fire({
      title: i18n.are_you_sure,
      text: i18n.expense.you_want_to_refund_expense,
      icon: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText:
        i18n.yes,
      cancelButtonText:
        i18n.no_cancel_it
    }).then(result => {
      if (result.value) {
        this.loaderService.startLoading();
        this.expenseService.refundExpense(form.value.uuid).subscribe(r => {
          this.loaderService.stopLoading();
          Swal.fire(i18n.done, i18n.expense.expense_refunded, 'success');
          this.getPage(1);
          // Trigger change event in parent component
          this.onChange.emit(true);
        }, err => {
          this.loaderService.stopLoading();
          Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        })
      }
    })
  }

  cancelEditFrom(form: FormGroup) {
    let fd = form.value;
    let inputTx = this.data.find(
      (obj: any) => obj.uuid == fd.uuid
    )
    form.reset(inputTx);
  }

}